import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

import { Button, Heading } from '@restworld/ui-ds-base';
import { cn } from '@restworld/utils-common';

import { FooterRow } from './report-candidate-layout';

// Modelled on discard-candidate/discard-candidate-success.tsx; the button lives in the footer so it stays
// visible on mobile.
export function ReportSuccess() {
  const { t } = useTranslation('job-positions-page');

  return (
    <Wrapper>
      <CheckCircleIcon className="h-6 w-6 text-neutral-700" />
      <Heading color="neutral" className="text-base lg:text-lg">
        {t('report.success_title')}
      </Heading>
      <ContentWrapper>{t('report.success_body')}</ContentWrapper>
    </Wrapper>
  );
}

export function ReportSuccessFooter({ onBackToCandidate }: { onBackToCandidate: () => void }) {
  const { t } = useTranslation('job-positions-page');

  return (
    <FooterRow className="lg:justify-end">
      <Button type="button" onClick={onBackToCandidate}>
        {t('report.back_to_candidate')}
      </Button>
    </FooterRow>
  );
}

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'h-full w-full max-w-[392px] mx-auto px-4 py-10 flex flex-col justify-center items-center gap-5 text-center',
      className
    )}
    {...props}
  />
);
const ContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('text-neutral-200 font-medium max-w-[316px]', className)} {...props} />
);
